import { Badge, ListItem, ListItemIcon, ListItemText, useMediaQuery, withStyles } from '@material-ui/core';
import { forwardRef, useMemo } from 'react';
import { Link } from 'react-router-dom';
import P from 'prop-types';

const StyledBadge = withStyles((theme) => ({
  badge: {
    right: 40,
    top: '80%',
    border: `2px solid ${theme.palette.background.paper}`,
    borderRadius: '50%',
    fontSize: '0.8rem',
    backgroundColor: '#f26522',
    color: '#fff',
    zIndex: 100,
    padding: '5px',
  },
}))(Badge);
// eslint-disable-next-line react/prop-types
export default function ListItemLink({ icon, text, to, count}) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  const CustomLink = useMemo(() => forwardRef((linkProps, ref) => <Link ref={ref} to={to} {...linkProps} />), [to]);
  const matchesH = useMediaQuery('(max-height:900px)');

  return (
    <ListItem style={{ paddingTop: matchesH ? '5px' : '8px' }} button component={CustomLink}>
      <StyledBadge badgeContent={count}>
        <ListItemIcon>{icon}</ListItemIcon>
      </StyledBadge>
      <ListItemText primary={text} />
    </ListItem>
  );
}

ListItemLink.propTypes = {
  icon: P.element.isRequired,
  text: P.string.isRequired,
  to: P.string.isRequired,
  count: P.number,
};

ListItemLink.defaultProps = {
  count: 0,
};
